<template>
  <div class="team-invite">
    <button
      :disabled="disabled"
      @click="showMemberForm = true"
      class="team-invite__button"
      :class="{ 'team-invite__button--disabled': disabled }"
    >
      <div class="team-invite__icon">
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7 7V1H9V7H15V9H9V15H7V9H1V7H7Z"
            fill="currentColor"
          />
        </svg>
      </div>
      <span class="team-invite__text">{{ title }}</span>
    </button>
    <Teleport to="#teleport-modal">
      <AddTeamMember
        v-if="showMemberForm"
        source="dealroom"
        @close-modal="showMemberForm = false"
        @success="toggleSuccessModal"
      />
      <SuccessModal
        v-if="showSuccessModal"
        @close="closeSuccessModal"
        :show="showSuccessModal"
        v-bind="{
          title: 'Success',
          body: 'You have added this user to your team. They have been notified via the provided email.',
        }"
      />
    </Teleport>
  </div>
</template>
  
<script setup>
import AddTeamMember from "./AddTeamMember.vue";
import SuccessModal from "@/components/general/SuccessModal.vue";
import { useStore } from "vuex";
import { onBeforeUnmount, ref } from "vue";

const store = useStore();

const emit = defineEmits(["member-added"]);

const props = defineProps({
  title: {
    type: String,
    default: () => "",
    required: true,
  },
  buttonType: {
    type: String,
    required: false,
    default: () => "",
  },
  disabled: {
    type: Boolean,
    required: false,
    default: () => false,
  },
});

const triggeredBy = ref(0);
const btnLoading = ref(false);
const showMemberForm = ref(false);
const showSuccessModal = ref(false);

const toggleSuccessModal = () => {
  showSuccessModal.value = true;
  showMemberForm.value = false;

  emit("member-added");
};

const closeSuccessModal = async () => {
  showSuccessModal.value = false;
};
</script>
  
<style lang="scss" scoped>
.team-invite {
  width: 100%;
  
  &__button {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    padding: 24px;
    background: linear-gradient(135deg, #4D84FF 0%, #6B9AFF 100%);
    border: none;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.2s ease;
    
    &:hover:not(.team-invite__button--disabled) {
      transform: translateY(-2px);
      box-shadow: 0 8px 20px rgba(77, 132, 255, 0.3);
    }
    
    &--disabled {
      background: #C2D3FF;
      cursor: not-allowed;
    }
  }
  
  &__icon {
    width: 36px;
    height: 36px;
    background: rgba(255, 255, 255, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
  }
  
  &__text {
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #ffffff;
    text-align: left;
  }
}
</style>